var map = {
	"./icon-apple.svg": "1e7a",
	"./icon-arrow-back.svg": "3b9f",
	"./icon-arrow-down.svg": "df06",
	"./icon-arrow-forward.svg": "8fca",
	"./icon-arrow-up.svg": "1ccd",
	"./icon-back.svg": "77ce",
	"./icon-bell.svg": "a730",
	"./icon-business.svg": "f05c",
	"./icon-calendar-purple.svg": "5da2",
	"./icon-calendar.svg": "9d9b",
	"./icon-chart.svg": "a289",
	"./icon-check-circle.svg": "49f6",
	"./icon-check.svg": "20f4",
	"./icon-checkbox-off.svg": "8233",
	"./icon-checkbox-on.svg": "64cd",
	"./icon-city.svg": "9403",
	"./icon-clients.svg": "814d",
	"./icon-clock.svg": "8b3f",
	"./icon-close-black.svg": "4f5c",
	"./icon-close.svg": "10c2",
	"./icon-codebusters.svg": "027d",
	"./icon-coin.svg": "1d73",
	"./icon-coins.svg": "2da5",
	"./icon-congrats.svg": "0548",
	"./icon-cookie.svg": "6bf9",
	"./icon-copy.svg": "aeb9",
	"./icon-detail-search.svg": "55e7",
	"./icon-details.svg": "c5ca",
	"./icon-discount.svg": "ff25",
	"./icon-dots.svg": "9ddb",
	"./icon-dropdown-arrow.svg": "363c",
	"./icon-dropdown-check.svg": "f7f5",
	"./icon-edit.svg": "0ef7",
	"./icon-email.svg": "1c76",
	"./icon-eye.svg": "70cf",
	"./icon-facebook.svg": "1f08",
	"./icon-filter.svg": "6dc3",
	"./icon-gallery.svg": "5cc8",
	"./icon-google.svg": "7178",
	"./icon-hand-down.svg": "4561",
	"./icon-hand.svg": "804d",
	"./icon-heart.svg": "8390",
	"./icon-info.svg": "bfb4",
	"./icon-instagram.svg": "5873",
	"./icon-invoice.svg": "79d9",
	"./icon-linkedin.svg": "4e1d",
	"./icon-loader.svg": "657b",
	"./icon-location-point.svg": "3cba",
	"./icon-location-purple.svg": "4ef0",
	"./icon-location-two.svg": "a104",
	"./icon-location.svg": "1c40",
	"./icon-logo.svg": "472c",
	"./icon-members.svg": "9b5c",
	"./icon-menu-arrow.svg": "065b",
	"./icon-menu-companies.svg": "7fdf",
	"./icon-menu-home.svg": "20e1",
	"./icon-mobile-nav.svg": "a791",
	"./icon-notes.svg": "df68",
	"./icon-offers.svg": "1c12",
	"./icon-phone.svg": "d8a4",
	"./icon-photo-upload.svg": "903a",
	"./icon-photo.svg": "3fe4",
	"./icon-play.svg": "384a",
	"./icon-plus-circle.svg": "0c02",
	"./icon-price-purple.svg": "4887",
	"./icon-price.svg": "39fd",
	"./icon-profile.svg": "49c8",
	"./icon-radio-off.svg": "e21f",
	"./icon-radio-on.svg": "b0b8",
	"./icon-rating-star.svg": "df38",
	"./icon-records.svg": "d595",
	"./icon-refresh.svg": "24e9",
	"./icon-reply-solid.svg": "d572",
	"./icon-reservation.svg": "ed9a",
	"./icon-retry.svg": "f6e9",
	"./icon-right-solid.svg": "2930",
	"./icon-schedule-cancel.svg": "3304",
	"./icon-search.svg": "f3ca",
	"./icon-services.svg": "1b77",
	"./icon-settings.svg": "2f48",
	"./icon-share.svg": "6af2",
	"./icon-sort.svg": "6b68",
	"./icon-star.svg": "154c",
	"./icon-statistics.svg": "8089",
	"./icon-success.svg": "436f",
	"./icon-support.svg": "e7cb",
	"./icon-theme-selected.svg": "46bd",
	"./icon-three-horizontal-dots.svg": "2d50",
	"./icon-tiktok.svg": "9612",
	"./icon-timedelay.svg": "35a6",
	"./icon-trash.svg": "c077",
	"./icon-twitter.svg": "7647",
	"./icon-url.svg": "d86f",
	"./icon-user-solid.svg": "1346",
	"./icon-user-tie.svg": "49ac",
	"./icon-users.svg": "14c4",
	"./icon-verified.svg": "7a3d",
	"./icon-viber.svg": "a797",
	"./icon-view.svg": "cba4",
	"./icon-warning.svg": "825d",
	"./icon-web.svg": "848e",
	"./icon-whatsapp.svg": "5568",
	"./icon-x-twitter.svg": "04c7",
	"./icon-youtube.svg": "07f6",
	"./picture-slider-left.svg": "52ed",
	"./picture-slider-right.svg": "e781"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "830a";